module.exports = __webpack_public_path__ + "img/logo.1a3768b8.png";